export default {
  name: 're-confirm',
  props: {
    config: {
      type: [Boolean, Function, Object],
      default: false
    },
    id: {
      type: [String, Function],
      default: ''
    },
    message: {
      type: [String, Function],
    },
    title: {
      type: [String, Function],
    },
    denyLabel: {
      type: [String, Function],
    },
    confirmLabel: {
      type: [String, Function],
    },
    confirmed: {
      type: [Function],
    },
    denied: {
      type: [Function],
      default: null,
    },
    containerClass: {
      type: [Array, String, Object],
      default: 're-modal-md'
    },
    noClose: {
      type: [Boolean, Function],
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    hasConfig() {
      return this.config !== false
    },
    options() {
      return this.hasConfig ?
        _.pick(this, ['message', 'title', 'denyLabel', 'confirmLabel', 'confirmed', 'denied']) :
          this.config
    }
  },
  methods: {
    close() {
      if (!this.options.denied) {
        this.$emit('close')
      } else {
        this.options.denied()
      }
    }
  }
}
